import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { TaskState } from './task.models';

export const selectTaskState = createFeatureSelector<TaskState>('task');

export const selectTaskProjects = createSelector(selectTaskState, (state) => state.projects);
export const selectTaskSprints = createSelector(selectTaskState, (state) => state.sprints);
export const selectTaskItems = createSelector(selectTaskState, (state) => state.tasks);
export const selectTaskDetail = createSelector(selectTaskState, (state) => state.detailTask);
export const selectTaskLoadingProjects = createSelector(selectTaskState, (state) => state.loadingProjects);
export const selectTaskLoadingSprints = createSelector(selectTaskState, (state) => state.loadingSprints);
export const selectTaskLoadingItems = createSelector(selectTaskState, (state) => state.loadingTasks);
export const selectTaskLoadingDetail = createSelector(selectTaskState, (state) => state.loadingDetail);
export const selectTaskNotifications = createSelector(selectTaskState, (state) => state.notifications);
export const selectTaskLoadingNotifications = createSelector(selectTaskState, (state) => state.loadingNotifications);
export const selectTaskUnreadNotificationCount = createSelector(selectTaskNotifications, (notifications) =>
  notifications.filter((item) => !item.read_at).length,
);
export const selectTaskSaving = createSelector(selectTaskState, (state) => state.saving);
export const selectTaskUploadingAttachment = createSelector(selectTaskState, (state) => state.uploadingAttachment);
export const selectTaskError = createSelector(selectTaskState, (state) => state.error);
export const selectTaskMessage = createSelector(selectTaskState, (state) => state.message);
export const selectTaskSuccess = createSelector(selectTaskState, (state) => state.success);
